import { render } from "./FourZeroFourView.vue?vue&type=template&id=9b0d7df2&scoped=true"
import script from "./FourZeroFourView.vue?vue&type=script&lang=js"
export * from "./FourZeroFourView.vue?vue&type=script&lang=js"

import "./FourZeroFourView.vue?vue&type=style&index=0&id=9b0d7df2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b0d7df2"]])

export default __exports__